module.exports = __webpack_public_path__ + "static/media/feature-1-video.037223f1.png";